<div>
  <page-header
    [title]="pageTitle"
    [subtitle]="subtitle"
  ></page-header>

  <div class="actions-container">
    <!-- Desktop view -->
    <div class="button-layout" *ngIf="!(isHandset$ | async)">
      <div class="left-button">
        <app-primary-button
          *ngIf="!isLandingPage"
          [title]="'Engage Home'"
          [disabled]="false"
          [icon]="'arrow_back'"
          (tapped)="openSection('')"
          [bgColor]="'var(--app-secondary)'"
          [color]="'white'"
          [border]="'1px solid white'"
        ></app-primary-button>
      </div>

      <div class="right-buttons">
        <app-primary-button
          *ngIf="canEngage && !isLandingPage"
          style="margin-left: 10px"
          [title]="selectedSectionAction.title"
          [disabled]="false"
          [icon]="selectedSectionAction.icon"
          (tapped)="runSelectedSectionAction()"
        ></app-primary-button>
      </div>
    </div>

    <!-- Mobile view -->
    <div class="mobile-actions" *ngIf="isHandset$ | async">
      <button
        *ngIf="!isLandingPage"
        class="home-link"
        type="button"
        (click)="openSection('')"
      >
        <mat-icon>arrow_back</mat-icon>
        Engage home
      </button>
      <app-primary-button
        *ngIf="!isLandingPage"
        [title]="selectedSectionAction.title"
        [icon]="selectedSectionAction.icon"
        (tapped)="runSelectedSectionAction()"
      ></app-primary-button>
    </div>
  </div>

  <ng-container *ngIf="isLandingPage; else sectionView">
    <!-- <section class="engage-intro">
      <div class="header-card">
        <h2>Engage customers</h2>
        <p>
          Choose the area you want to manage. Each section keeps its own
          messages, settings and reporting focused in one place.
        </p>
      </div>
    </section> -->

    <section class="engage-card-grid">
      <article
        class="engage-card"
        [class.is-loading]="homeCardsLoading"
        [class.is-locked]="!card.enabled && !homeCardsLoading"
        *ngFor="let card of sectionCards; trackBy: trackSectionCard"
        (click)="openSection(card.key)"
      >
        <h3 class="card-title">
          <mat-icon fontSet="material-icons-outlined">{{ card.icon }}</mat-icon>
          <span>{{ card.title }}</span>
        </h3>
        <p *ngIf="!homeCardsLoading; else cardDescriptionLoading">
          {{ card.description }}
        </p>
        <ng-template #cardDescriptionLoading>
          <span class="shimmer-line"></span>
          <span class="shimmer-line shimmer-line-short"></span>
        </ng-template>
        <div class="engage-card-footer">
          <span
            *ngIf="homeCardsLoading || card.stat"
            class="card-stat-chip"
            [class.shimmer-pill]="homeCardsLoading"
          >
            <ng-container *ngIf="!homeCardsLoading">{{
              card.stat
            }}</ng-container>
          </span>
          <button
            class="card-action-button"
            [class.shimmer-action]="homeCardsLoading"
            [disabled]="homeCardsLoading"
            type="button"
            (click)="openSection(card.key); $event.stopPropagation()"
          >
            <ng-container *ngIf="!homeCardsLoading">
              {{ card.action }}
              <mat-icon>{{ card.enabled ? "arrow_forward" : "lock" }}</mat-icon>
            </ng-container>
          </button>
        </div>
      </article>
    </section>
  </ng-container>

  <ng-template #sectionView>
    <div class="detail-container section-detail" style="margin-top: 10px">
      <ng-container *ngIf="selectedTab === 'messages'">
        <ngx-datatable
          #messageTable
          class="material"
          [headerHeight]="45"
          [rows]="messagesLoading ? tableSkeletonRows : messages"
          [scrollbarV]="false"
          [scrollbarH]="true"
          [footerHeight]="50"
          [columnMode]="'force'"
          [rowHeight]="60"
          [externalPaging]="true"
          [messages]="{
            emptyMessage: canEngage
              ? '<a href=https://app.remyrewards.co.uk/engage-push>+ Create your first Push Notification</a>'
              : 'No messages',
          }"
          [count]="messagesLoading ? pageSize : messageLength"
          [offset]="messagePageIndex"
          (page)="messagePageEvent($event)"
          (activate)="!messagesLoading && rowTappedNGX($event, false)"
          (scroll)="handleScroll()"
          [limit]="pageSize"
        >
          <ngx-datatable-column name="Date" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else messageDate"
                class="table-cell-shimmer"
              ></span>
              <ng-template #messageDate>
                {{ row?.createdAt | date: constants.longDate }}
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="Message"
            [width]="250"
            [resizeable]="false"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else messageBody"
                class="table-cell-shimmer table-cell-shimmer-wide"
              ></span>
              <ng-template #messageBody>
                {{ row?.message ?? "" | truncate: 40 }}
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="# Recipients" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else messageRecipients"
                class="table-cell-shimmer table-cell-shimmer-short"
              ></span>
              <ng-template #messageRecipients>
                {{ (row?.recipients ?? 0) === 0 ? "-" : row?.recipients }}
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Click Rate %" [resizeable]="false">
            <ng-template ngx-datatable-header-template>
              Click Rate
              <span>
                <info-icon
                  text="Clicks are registered only when a customer taps on the push notification, if they simply dismiss it will not count as a click, clicks do not necessarily equate to reads"
                ></info-icon>
              </span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else messageClickRate"
                class="table-cell-shimmer table-cell-shimmer-short"
              ></span>
              <ng-template #messageClickRate>
                {{ clickRate(row) }}
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Reward" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else messageReward"
                class="table-cell-shimmer table-cell-shimmer-icon"
              ></span>
              <ng-template #messageReward>
                <mat-icon
                  class="status-icon"
                  style="color: green"
                  *ngIf="row?.reward"
                  >check_circle</mat-icon
                >
                <mat-icon
                  class="status-icon"
                  style="color: red"
                  *ngIf="!row?.reward"
                  >cancel</mat-icon
                >
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="Status"
            [resizeable]="false"
            [minWidth]="200"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else messageStatus"
                class="table-cell-shimmer table-cell-shimmer-pill"
              ></span>
              <ng-template #messageStatus>
                <div
                  id="status-chip"
                  [ngClass]="
                    row?.draft
                      ? 'status-chip-unredeemed'
                      : 'status-chip-redeemed'
                  "
                  [innerHTML]="status(row)"
                ></div>
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Actions" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else messageActions"
                class="table-cell-shimmer table-cell-shimmer-icon"
              ></span>
              <ng-template #messageActions>
              <div
                class="actions-icon-container"
                [matTooltip]="'More actions'"
                [matTooltipShowDelay]="500"
                [mat-menu-trigger-for]="rowMenu"
                [matMenuTriggerData]="{ row: row }"
                (click)="$event.stopPropagation()"
              >
                <mat-icon>more_horiz</mat-icon>
              </div>
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-footer>
            <ng-template
              ngx-datatable-footer-template
              let-rowCount="rowCount"
              let-pageSize="pageSize"
              let-offset="offset"
              let-isVisible="isVisible"
            >
              <ng-container *ngIf="!messagesLoading; else tableFooterLoading">
                <div class="page-count" *ngIf="messageLength > 0">
                  <span>{{ messagesRange }}</span>
                </div>

                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="messagePageIndex + 1"
                  [size]="pageSize"
                  [count]="messageLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="messageTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-container>
            </ng-template>
          </ngx-datatable-footer>
        </ngx-datatable>
      </ng-container>

      <ng-container
        *ngIf="selectedTab === 'birthday' && (hasBirthdayClubAccess || birthdayLoading)"
      >
        <ngx-datatable
          #birthdayTable
          class="material"
          [headerHeight]="45"
          [rows]="birthdayLoading ? tableSkeletonRows : birthdayNotifications"
          [scrollbarV]="false"
          [scrollbarH]="true"
          [footerHeight]="50"
          [columnMode]="'force'"
          [rowHeight]="48"
          [externalPaging]="true"
          [messages]="{
            emptyMessage: 'Sent Birthday Club messages will show here',
          }"
          [count]="birthdayLoading ? pageSize : birthdayLength"
          [offset]="birthdayPageIndex"
          (page)="birthdayPageEvent($event)"
          (activate)="!birthdayLoading && rowTappedNGX($event, true)"
          (scroll)="handleScroll()"
          [limit]="pageSize"
        >
          <ngx-datatable-column name="Date" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else birthdayDate"
                class="table-cell-shimmer"
              ></span>
              <ng-template #birthdayDate>
                {{ row?.createdAt | date: constants.longDate }}
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="Message"
            [width]="250"
            [resizeable]="false"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else birthdayMessage"
                class="table-cell-shimmer table-cell-shimmer-wide"
              ></span>
              <ng-template #birthdayMessage>
                {{ row?.message | truncate: 40 }}
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Customer" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else birthdayCustomer"
                class="table-cell-shimmer"
              ></span>
              <ng-template #birthdayCustomer>
                <ng-container *ngIf="canViewCustomers; else noLink">
                  <a
                    [routerLink]="['/customer', row?.customer?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ row?.customer?.user?.name ?? row?.customer?.name }}
                  </a>
                </ng-container>
                <ng-template #noLink>
                  {{ row?.customer?.user?.name ?? row?.customer?.name }}
                </ng-template>
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Reward" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else birthdayReward"
                class="table-cell-shimmer table-cell-shimmer-short"
              ></span>
              <ng-template #birthdayReward>
                {{ row?.data?.reward?.title || "-" }}
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Clicked" [resizeable]="false">
            <ng-template ngx-datatable-header-template>
              Clicked
              <span>
                <info-icon
                  text="Clicks are registered only when a customer taps on the push notification, if they simply dismiss it will not count as a click, clicks do not necessarily equate to reads"
                ></info-icon>
              </span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else birthdayClicked"
                class="table-cell-shimmer table-cell-shimmer-icon"
              ></span>
              <ng-template #birthdayClicked>
                <mat-icon
                  class="status-icon"
                  style="color: green"
                  *ngIf="row?.delivered || row?.seen"
                  >check_circle</mat-icon
                >
                <mat-icon
                  class="status-icon"
                  style="color: red"
                  *ngIf="!row?.delivered && !row?.seen"
                  >cancel</mat-icon
                >
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Reward Status" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else birthdayRewardStatus"
                class="table-cell-shimmer table-cell-shimmer-pill"
              ></span>
              <ng-template #birthdayRewardStatus>
                <div
                  *ngIf="row?.data?.reward?.title"
                  id="status-chip"
                  [ngClass]="constants.statusChipClass(row?.userReward)"
                >
                  {{ constants.statusChipLabel(row?.userReward) }}
                </div>
                <div *ngIf="!row?.data?.reward?.title">-</div>
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-footer>
            <ng-template
              ngx-datatable-footer-template
              let-rowCount="rowCount"
              let-pageSize="pageSize"
              let-offset="offset"
              let-isVisible="isVisible"
            >
              <ng-container *ngIf="!birthdayLoading; else tableFooterLoading">
                <div class="page-count" *ngIf="birthdayLength > 0">
                  <span>{{ birthdayRange }}</span>
                </div>

                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="birthdayPageIndex + 1"
                  [size]="pageSize"
                  [count]="birthdayLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="birthdayTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-container>
            </ng-template>
          </ngx-datatable-footer>
        </ngx-datatable>
      </ng-container>

      <ng-container
        *ngIf="selectedTab === 'automations' && hasAutomationsAccess"
      >
        <automations-list #automationsList [embedded]="true"></automations-list>
      </ng-container>

      <ng-container
        *ngIf="selectedTab === 'conversations' && showConversationsTab"
      >
        <ngx-datatable
          #conversationTable
          class="material"
          [headerHeight]="45"
          [rows]="conversationsLoading ? tableSkeletonRows : conversations"
          [scrollbarV]="false"
          [scrollbarH]="true"
          [footerHeight]="50"
          [columnMode]="'force'"
          [rowHeight]="60"
          [externalPaging]="true"
          [messages]="{
            emptyMessage: 'No conversations',
          }"
          [count]="conversationsLoading ? pageSize : conversationLength"
          [offset]="conversationPageIndex"
          (page)="messagePageEvent($event)"
          (activate)="!conversationsLoading && rowTappedNGX($event, false)"
          (scroll)="handleScroll()"
          [limit]="pageSize"
        >
          <ngx-datatable-column name="Last Message" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else conversationDate"
                class="table-cell-shimmer"
              ></span>
              <ng-template #conversationDate>
                {{ row?.lastMessage?.createdAt | date: constants.longDate }}
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Customer" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else conversationCustomer"
                class="table-cell-shimmer table-cell-shimmer-short"
              ></span>
              <ng-template #conversationCustomer>
                {{ row?.user?.name ?? row?.customer?.name }}
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Message" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else conversationMessage"
                class="table-cell-shimmer table-cell-shimmer-wide"
              ></span>
              <ng-template #conversationMessage>
                {{ row?.lastMessage?.text ?? "" | truncate: 40 }}
                <span class="new-chip" *ngIf="!seen(row)">NEW</span>
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="Status"
            [resizeable]="false"
            [minWidth]="200"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else conversationStatusTemplate"
                class="table-cell-shimmer table-cell-shimmer-pill"
              ></span>
              <ng-template #conversationStatusTemplate>
                <div
                  id="status-chip"
                  [ngClass]="
                    conversationStatus(row) === 'Blocked'
                      ? 'status-chip-expired'
                      : conversationStatus(row) === 'Muted'
                        ? 'status-chip-unredeemed'
                        : 'status-chip-redeemed'
                  "
                >
                  {{ conversationStatus(row) }}
                  <span *ngIf="showInfoIcon(row)"
                    ><info-icon [text]="infoIconText(row)"></info-icon
                  ></span>
                </div>
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Actions" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row?.__loading; else conversationActions"
                class="table-cell-shimmer table-cell-shimmer-icon"
              ></span>
              <ng-template #conversationActions>
              <div
                class="actions-icon-container"
                [matTooltip]="'More actions'"
                [matTooltipShowDelay]="500"
                [mat-menu-trigger-for]="conversationMenu"
                [matMenuTriggerData]="{ row: row }"
                (click)="$event.stopPropagation()"
              >
                <mat-icon>more_horiz</mat-icon>
              </div>
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-footer>
            <ng-template
              ngx-datatable-footer-template
              let-rowCount="rowCount"
              let-pageSize="pageSize"
              let-offset="offset"
              let-isVisible="isVisible"
            >
              <ng-container
                *ngIf="!conversationsLoading; else tableFooterLoading"
              >
                <div class="page-count" *ngIf="conversationLength > 0">
                  <span>{{ conversationsRange }}</span>
                </div>

                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="conversationPageIndex + 1"
                  [size]="pageSize"
                  [count]="conversationLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="conversationTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-container>
            </ng-template>
          </ngx-datatable-footer>
        </ngx-datatable>
      </ng-container>
    </div>
  </ng-template>
  <ng-template #tableFooterLoading>
    <div class="table-footer-loading" aria-hidden="true">
      <span class="table-cell-shimmer table-footer-count-shimmer"></span>
      <span class="table-cell-shimmer table-footer-pager-shimmer"></span>
    </div>
  </ng-template>
</div>

<loader [loading]="blockingLoading"></loader>

<mat-menu #actionsMenu="matMenu" class="custom-menu">
  <div *ngFor="let item of menuOptions; let i = index">
    <button
      [disabled]="false"
      [style.cursor]="'pointer'"
      class="menu-list-item"
      style="border-radius: 5px"
      (click)="onClick(item.title, null)"
      mat-menu-item
    >
      <mat-icon
        fontSet="material-icons-outlined"
        style="
          font-size: 16px;
          vertical-align: middle;
          display: flex;
          align-items: center;
          margin-right: 5px;
        "
        >{{ item.icon }}</mat-icon
      >
      <span class="menu-list-item-label">{{ item.title }}</span>
    </button>
  </div>
</mat-menu>

<mat-menu #rowMenu="matMenu" class="custom-menu">
  <ng-template matMenuContent let-row="row">
    <div *ngFor="let item of row | rowMenuOptions: constants">
      <button
        [disabled]="false"
        class="menu-list-item"
        style="border-radius: 5px; cursor: pointer"
        (click)="onClick(item.title, row)"
        mat-menu-item
      >
        <mat-icon
          fontSet="material-icons-outlined"
          style="
            font-size: 16px;
            vertical-align: middle;
            display: flex;
            align-items: center;
            margin-right: 5px;
          "
        >
          {{ item.icon }}
        </mat-icon>
        <span class="menu-list-item-label">{{ item.title }}</span>
      </button>
    </div>
  </ng-template>
</mat-menu>

<mat-menu #conversationMenu="matMenu" class="custom-menu">
  <ng-template matMenuContent let-row="row">
    <div *ngFor="let item of row | conversationMenuOptions: constants">
      <button
        [disabled]="false"
        class="menu-list-item"
        style="border-radius: 5px; cursor: pointer"
        (click)="onClick(item.title, row)"
        mat-menu-item
      >
        <mat-icon
          fontSet="material-icons-outlined"
          style="
            font-size: 16px;
            vertical-align: middle;
            display: flex;
            align-items: center;
            margin-right: 5px;
          "
        >
          {{ item.icon }}
        </mat-icon>
        <span class="menu-list-item-label">{{ item.title }}</span>
      </button>
    </div>
  </ng-template>
</mat-menu>
